import { MarginBookingEngine } from "../../margin/objects/margin";
import { Column } from "../objects/column";
import { EMPTY_FLIGHT_SPECIFIC_LEVEL } from "../objects/flightSpecificLevel";
import { MarginForm, MarginLevel, MarginLevelPeriod, MarginLevelTripPeriod } from "../objects/marginFlightForm";
import { MarginFlightListConfiguration, MarginFlightListFilters, MarginFlightListCriteria } from "../objects/marginFlightList";
import { Rate } from "../objects/rate";

export const MARGIN_FLIGHT_MODULE = 'MARGIN_FLIGHT';

export const EMPTY_MARGIN_LIST_FILTERS: MarginFlightListFilters = {
    activated: 'ACTIVATED',
    organisation: null,
    network: null,
    content_type: 6,
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION"
};

export const EMPTY_MARGIN_LIST_CRITERIA: MarginFlightListCriteria = {
    limit: 50,
    page: 0,
    order: "asc",
    order_by: "",
    filters: EMPTY_MARGIN_LIST_FILTERS,
    search: ""
};


export const MARGIN_FLIGHT_COLUMN: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },  {
        label: 'booking-engines',
        field_name: 'BOOKING_ENGINES',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'margin-specifics',
        field_name: 'MARGIN_SPECIFICS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'margin',
        field_name: 'MARGIN',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'currency',
        field_name: 'CURRENCY',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'start-date',
        field_name: 'START_DATE',
        checked: false,
        order_by: 'start_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'end-date',
        field_name: 'END_DATE',
        checked: false,
        order_by: 'end_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'activated',
        field_name: 'ACTIVATED',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }
];

export const EMPTY_MARGIN_FLIGHT_LIST_CONFIGURATION: MarginFlightListConfiguration = {
    columns: MARGIN_FLIGHT_COLUMN,
    preferences: [],
};




export const EMPTY_RATE: Rate = {
    applied_under: null,
    currency: null,
    rate: 0,
    rate_type: 'FIX'
};
export const EMPTY_MARGIN_LEVEL_PERIOD: MarginLevelPeriod = {
    date_gte: null,
    date_lte: null,
    rate: EMPTY_RATE
};
export const EMPTY_MARGIN_LEVEL_TRIP_PERIOD: MarginLevelTripPeriod = {
    trip_creation_start_date: null,
    trip_creation_end_date: null
};
export const EMPTY_MARGIN_LEVEL: MarginLevel = {
    periods: [],
    // periods: [EMPTY_MARGIN_LEVEL_PERIOD],
    trip_periods: [],
    rates: [EMPTY_RATE],
    flight_specifics_levels: [EMPTY_FLIGHT_SPECIFIC_LEVEL],
    is_multi_specifics: false
};

export const EMPTY_MARGIN: MarginForm = {
    name: {},
    content_type: [6],
    type: 5,
    booking_engines: Object.values(MarginBookingEngine),
    is_markup: false,
    cms: [],
    companies: [],
    levels: [EMPTY_MARGIN_LEVEL],
    is_multi_condition: false,
    destinations: []
};